import { render } from "./Hobbies.vue?vue&type=template&id=dace4944&scoped=true"
import script from "./Hobbies.vue?vue&type=script&lang=js"
export * from "./Hobbies.vue?vue&type=script&lang=js"

import "./Hobbies.vue?vue&type=style&index=0&id=dace4944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dace4944"]])

export default __exports__